import React, { useState, useEffect } from "react";
import Header from "../../generalPages/directives/header";
import Footer from "../commanComponents/userfooter";
import config from "../../coreFIles/config";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Dropdown,
  InputGroup,
  Modal,
  Form,
} from "react-bootstrap";
import "../commanComponents/componentCSS/propertydetail.css";
import "../commanComponents/componentCSS/vehicledetail.css";
import {
  getVehicleDetailActionbyid,
  addWishlistAction,
  removeFromWishlistAction,
  checkvehicleBookingDetailsAction,
  getVehicleAvailableDataAction,
  getWishListAction,
} from "../../Action/user.action";
import { insertSupportRequestAction } from "../../Action/propertyOwner.action";
import { toast, Toaster } from "react-hot-toast";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { AiOutlineHeart, AiFillHeart, AiFillStar } from "react-icons/ai";
import { RxCopy } from "react-icons/rx";
import { Formik } from "formik";
import { AddTicketSchema } from "../../validations/ticket";
import { BsShare, BsWhatsapp } from "react-icons/bs";
import "../commanComponents/componentCSS/listingproperty.css";
import { useNavigate } from "react-router-dom";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { FaMusic, FaBluetoothB } from "react-icons/fa";
import {
  MdElectricCar,
  MdGpsFixed,
  MdOutlineKeyboardVoice,
} from "react-icons/md";
import { GiSteeringWheel } from "react-icons/gi";
import { LuDog } from "react-icons/lu";
import { IoSunnyOutline } from "react-icons/io5";
import { BsFillFuelPumpDieselFill } from "react-icons/bs";
import { FaStar } from "react-icons/fa6";
import Cookies from "js-cookie";
import {
  LinkedinShareButton,
  FacebookShareButton,
  EmailShareButton,
  WhatsappShareButton,
} from "react-share";
import {
  AiFillFacebook,
  AiFillInstagram,
  AiFillLinkedin,
  AiFillWechat,
} from "react-icons/ai";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../commanComponents/componentCSS/swiper.css";
// import required modules
import { Pagination, Navigation } from "swiper/modules";

const loginData = !Cookies.get("loginSuccessPropertyOwner")
  ? []
  : JSON.parse(Cookies.get("loginSuccessPropertyOwner"));

const VehicleDetails = () => {
  const [show, setShow] = useState(false);
  const [isViewOpen, setisViewOpen] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseHost = () => setisHostRequestOpen(false);
  const handleOpenHost = () => setisHostRequestOpen(true);
  const handleCloseview = () => setisViewOpen(false);
  const handleOpenview = () => setisViewOpen(true);

  const {
    id,
    checkin,
    checkout,
    checkintime,
    checkouttime,
    propertyPurchaseTypeId,
  } = useParams();
  const navigate = useNavigate();

  const [vehicleDetails, setvehicleDetails] = useState({
    vehicleName: "",
    engineArr: [],
    vehicleFeatures: [],
    bikeParking: "",
    carParking: "",
    categoryName: "",
    checkIn: "",
    checkOut: "",
    datetime: "",
    description: "",

    email: "",

    id: "",
    imageArr: [],
    isDeleted: "",
    location: "",

    price: "",
    vehicleName: "",
    propertyPurchaseType: "",
    propertyPurchaseTypeId: "",
    status: "",
    terms: "",
  });
  const [imagesArr, setimagesArr] = useState([]);
  const [engineArr, setengineArr] = useState([]);
  const [vehicleFeaturesArr, setvehicleFeaturesArr] = useState([]);
  const [passengerCount, setpassengerCount] = useState({
    passenger: 0,
  });
  const [isHostRequestOpen, setisHostRequestOpen] = useState(false);
  const [wishList, setwishList] = useState([]);
  const [values, setValues] = useState([
    new DateObject(),
    new DateObject().add(1, "day"),
  ]);

  const [bookingDates, setBookingDates] = useState({
    startDate: "",
    endDate: "",
  });
  const [checkIntime, setcheckIntime] = useState();
  const [checkOutTime, setcheckOutTime] = useState();
  const [totalBookingHour, settotalBookingHour] = useState(0);
  const [availableVehicle, setAvailableVehicle] = useState(0);

  useEffect(() => {
    getListingDetails();
    getwishList();
    localStorage.clear("PropertDetail");
  }, []);

  const getListingDetails = async () => {
    let res = await getVehicleDetailActionbyid({ id: id, checkInDateTime: `${checkin}`, checkOutDateTime: `${checkout}` });
    console.log(res.data, "vehcileOnwerNAme");
    if (res.success) {
      setvehicleDetails(res.data);
      setimagesArr(JSON.parse(res.data.imageArr));
      console.log(JSON.parse(res.data.imageArr));
      setvehicleFeaturesArr(res.data.vehicleFeatures);
      setengineArr(res.data.engineArr);
    }
    if (checkin && checkout) {
      setBookingDates((old) => {
        return { ...old, ["startDate"]: checkin, ["endDate"]: checkout };
      });

      setValues([new DateObject(checkin), new DateObject(checkout)]);
      //Difference in number of days
      var date1 = new Date(checkin);
      var date2 = new Date(checkout);
      setcheckIntime(checkintime);
      setcheckOutTime(checkouttime);

      const getHoursDiffBetweenDates = (dateInitial, dateFinal) =>
        (dateFinal - dateInitial) / (1000 * 3600);
      const hour = getHoursDiffBetweenDates(date1, date2);
      settotalBookingHour(hour);
    }
  };

  const getwishList = async () => {
    if (loginData?.id) {
      let res = await getWishListAction({});
      if (res.success) {
        setwishList(res.data.vehicleList);
      } else {
        setwishList([]);
      }
    }
  };

  const createMarkup = () => {
    return { __html: vehicleDetails.description };
  };

  const createMarkupTerms = () => {
    return { __html: vehicleDetails.terms };
  };

  useEffect(() => {
    if (values[0].format()) {
      setBookingDates((old) => {
        return { ...old, ["startDate"]: values[0].format() };
      });
    }

    if (values.length > 1) {
      setBookingDates((old) => {
        return { ...old, ["endDate"]: values[1].format() };
      });

      const start = new Date(String(values[0].format()));
      const end = new Date(String(values[1].format()));

      // navigate(
      //   `${config.baseUrl}vehicledetail/${id}/${propertyPurchaseTypeId}/${moment(values[0].format()).format("YYYY-MM-DD HH:mm")}/${moment(values[1].format()).format("YYYY-MM-DD HH:mm")}`
      // );

      const getHoursDiffBetweenDates = (dateInitial, dateFinal) =>
        (dateFinal - dateInitial) / (1000 * 3600);
      const hour = getHoursDiffBetweenDates(start, end);
      settotalBookingHour(hour);
      getVehicleAvailableData(moment(values[0].format()).format("YYYY-MM-DD"), moment(values[1].format()).format("YYYY-MM-DD"), moment(values[0].format()).format("HH:mm:ss"), moment(values[1].format()).format("HH:mm:ss"))
    }
  }, [values]);

  const getVehicleAvailableData = async (check_in_date, check_out_date, pickUp, dropOff) => {
    let res = await getVehicleAvailableDataAction(
      {
        vehicleId: id,
        checkInDate: check_in_date,
        checkOutDate: check_out_date,
        checkInTime : pickUp,
        checkOutTime : dropOff
      });
    if (res.success) {
      setAvailableVehicle(res.data[0].availableVehicle)
    }
  }

  const bookHandler = async () => {
    if (loginData.length == 0) {
      localStorage.setItem(
        "PropertDetail",
        `${config.baseUrl
        }vehicledetail/${id}/${propertyPurchaseTypeId}/${moment(
          bookingDates.startDate
        ).format("YYYY-MM-DD HH:mm")}/${moment(bookingDates.endDate).format(
          "YYYY-MM-DD HH:mm"
        )}`
      );
      window.location.href = `${config.baseUrl}userlogin`;
    } else {
      // let arr = {
      //   vehicleId: parseInt(id),
      //   paymentMethodId: 1,
      //   checkInDate: bookingDates.startDate,
      //   passenger: passengerCount.passenger,
      //   checkOutDate: bookingDates.endDate,
      //   checkInTime:
      //     ("0" + new Date(bookingDates.startDate).getHours()).slice(-2) +
      //     ":" +
      //     ("0" + new Date(bookingDates.startDate).getMinutes()).slice(-2),
      //   checkOutTime:
      //     ("0" + new Date(bookingDates.endDate).getHours()).slice(-2) +
      //     ":" +
      //     ("0" + new Date(bookingDates.endDate).getMinutes()).slice(-2),
      //   locationPickup: true,
      //   amount:
      //     parseInt(vehicleDetails.perHourRate) * parseInt(totalBookingHour),
      //   status: 1,
      //   upiId: "",
      // };
      // let result = await checkvehicleBookingDetailsAction(arr);
      if (parseInt(availableVehicle) == 0) {
        navigate(
          `${config.baseUrl}vehiclepayment/${id}/${moment(
            bookingDates.startDate
          ).format("YYYY-MM-DD HH:mm:ss")}/${moment(
            bookingDates.endDate
          ).format("YYYY-MM-DD HH:mm:ss")}/${passengerCount.passenger}`
        );
      } else {
        toast.error('Sorry, the vehicle is not available on the specified date and time as it has been already booked.');
      }
    }
  };

  const addToWishList = async (e, id, type, status) => {
    if (loginData?.id) {
      let res =
        status == 1
          ? await addWishlistAction({ id: id, type: type })
          : await removeFromWishlistAction({ id: id, type: type });
      if (res.success) {
        toast.success(res.msg);
        getListingDetails();
        getwishList();
      } else {
        toast.error(res.msg);
      }
    } else {
      toast.error(
        "Please login first  You can add vehicles to your wishlist after logging in."
      );
      getwishList();
    }
  };
  const formSubmit = async (data) => {
    data.propertyId = id;
    data.type = 2;
    data.ticketType = 2;
    data.touserId = vehicleDetails?.ownerId;
    if (loginData?.id) {
      let res = await insertSupportRequestAction(data);
      if (res.success) {
        toast.success(res.msg);
        setisHostRequestOpen(false);
      } else {
        toast.error(res.msg);
      }
    } else {
      toast.error("You must be logged in first!");
    }
  };
  const copyText = () => {
    toast.success("Copied!");
    navigator.clipboard.writeText(window.location);
  };

  return (
    <>
      <Header />
      <section className="vehicleDetails  pt-0 pb-0 overflow-hidden">
        <Container className="mt-5">
          <Toaster />
          <Row className="align-items-center">
            <Col lg={6}>
              <h3>
                <b>{vehicleDetails.vehicleName}</b>
              </h3>
              <p className="mb-0">{vehicleDetails.location}</p>
            </Col>
            <Col lg={6} className="text-right">
              <div className="socialicon">
                <span className="me-3">
                  <AiFillStar fill="#E46422" width="20px" /> &nbsp;
                  {vehicleDetails.ratingArr == null
                    ? "0"
                    : parseFloat(
                      JSON.parse(vehicleDetails.ratingArr)
                        .map((items) => items.ratings)
                        .reduce((prev, next) => prev + next) /
                      JSON.parse(vehicleDetails.ratingArr).length
                    ).toFixed(1)}
                  {/* 4.8 */}
                </span>
                <span className="me-3">
                  {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 27" fill="none">
                                        <path d="M5.33837 16.8485C5.00216 16.5621 4.72981 16.3295 4.52488 16.1543V16.0522L4.06954 15.6103C2.42856 14.0177 1.5 11.9258 1.5 9.73391V9.44938C1.64494 5.21526 5.38922 1.65451 9.87065 1.65451C10.5309 1.65451 11.4074 1.87753 12.2804 2.33371C13.1018 2.76294 13.8161 3.34455 14.2882 3.98525C15.0256 5.48946 17.2295 5.46074 17.9109 3.8991C18.2987 3.24397 18.9838 2.64001 19.8185 2.18827C20.6901 1.7165 21.5599 1.5 22.1294 1.5C26.7393 1.5 30.3546 5.03105 30.5 9.44855V9.73391C30.5 12.1046 29.5556 14.1627 27.9781 15.566L27.4751 16.0135V16.1117C27.2395 16.306 26.9425 16.5548 26.5998 16.844C25.7944 17.5236 24.7162 18.4441 23.5424 19.4481C23.1659 19.7702 22.7795 20.1009 22.3889 20.4351C20.3444 22.1849 18.1849 24.033 16.7204 25.2607C16.3175 25.5798 15.6825 25.5798 15.2796 25.2607C13.5312 23.7951 10.7554 21.4476 8.39314 19.444C7.20958 18.4402 6.13084 17.5235 5.33837 16.8485Z" stroke="black" stroke-width="3" />
                                    </svg> */}

                  {wishList.length > 0 &&
                    wishList.find(
                      (wishitem) =>
                        wishitem.vehicleId == vehicleDetails.id &&
                        wishitem.status == 1 &&
                        wishitem.userId == loginData?.id
                    ) ? (
                    <AiFillHeart
                      width="20px"
                      fill="#D8000C"
                      onClick={(e) => addToWishList(e, vehicleDetails.id, 2, 0)}
                    />
                  ) : (
                    <AiOutlineHeart
                      width="20px"
                      fill="#D8000C"
                      AiOutlineHeart
                      onClick={(e) => addToWishList(e, vehicleDetails.id, 2, 1)}
                    />
                  )}
                </span>
                <span>
                  <Button
                    variant="transparent"
                    className="border-0 "
                    onClick={handleShow}
                  >
                    {" "}
                    <BsShare />
                  </Button>
                  <Modal show={show} onHide={handleClose} size="md">
                    <Modal.Header closeButton>
                      <Modal.Title>
                        <b>Share this vehicle detail</b>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="d-flex align-items-center">
                        <div className="me-2">
                          {imagesArr.length > 0 ? (
                            <img
                              // src="assets/images/property2.svg"
                              src={imagesArr[0]?.fileNameImage}
                              height={`62px`}
                              width={`100px`}
                              className="object-fit-contain rounded-2"
                            />
                          ) : (
                            <img
                              src="assets/images/property2.svg"
                              height={`62px`}
                              width={`100px`}
                              className="object-fit-contain rounded-2"
                            />
                          )}
                        </div>
                        <div>
                          <p className="mb-0">
                            vehicle in ${vehicleDetails.perHourRate} · per hour
                            rate
                          </p>
                        </div>
                      </div>
                      <div>
                        <br />
                        <Row>
                          <Col lg={6} className="mb-3">
                            <Button
                              variant="transparent"
                              className="rounded-3 w-100 border-1 border-secondary"
                              onClick={(e) => copyText(e)}
                            >
                              <RxCopy size={23} fill="#E46422" />
                              &nbsp; Copy Link
                            </Button>
                          </Col>
                          <Col lg={6} className="mb-3">
                            <Button
                              variant="transparent"
                              className="rounded-3 w-100 border-1 border-secondary"
                            >
                              <LinkedinShareButton
                                url={`www.ihatereading.in/createrepo?framework=Create-React-App&repoId=${5}`}
                                title="Check out this iHateReading custom repository "
                              >
                                <AiFillLinkedin fill="#0072b1" size={23} />
                                &nbsp; Linkedin
                              </LinkedinShareButton>
                            </Button>
                          </Col>

                          <Col lg={6} className="mb-3">
                            <Button
                              variant="transparent"
                              className="rounded-3 w-100 border-1 border-secondary"
                            >
                              <WhatsappShareButton
                                url={`www.ihatereading.in/createrepo?framework=Create-React-App&repoId=${5}`}
                                title="Check out this iHateReading custom repository "
                              >
                                <BsWhatsapp fill="#25d366" size={23} />
                                &nbsp; Whatsapp
                              </WhatsappShareButton>
                            </Button>
                          </Col>
                          <Col lg={6} className="mb-3">
                            <Button
                              variant="transparent"
                              className="rounded-3 w-100 border-1 border-secondary"
                            >
                              <FacebookShareButton
                                url={`www.ihatereading.in/createrepo?framework=Create-React-App&repoId=${5}`}
                                title="Check out this iHateReading custom repository "
                              >
                                <AiFillFacebook fill="#1877F2" size={23} />{" "}
                                Facebook
                              </FacebookShareButton>
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </Modal.Body>
                  </Modal>
                  <div className="d-none">
                    <WhatsappShareButton
                      url={`www.ihatereading.in/createrepo?framework=Create-React-App&repoId=${5}`}
                      title="Check out this iHateReading custom repository "
                    >
                      <AiFillWechat style={{ opacity: "0.5" }} size={18} />
                    </WhatsappShareButton>
                    <FacebookShareButton
                      url={`www.ihatereading.in/createrepo?framework=Create-React-App&repoId=${5}`}
                      title="Check out this iHateReading custom repository "
                    >
                      <AiFillFacebook style={{ opacity: "0.5" }} size={18} />
                    </FacebookShareButton>
                  </div>
                  {/* <EmailShareButton
                                        url={`www.ihatereading.in/createrepo?framework=Create-React-App&repoId=${5}`}
                                        title="Check out this iHateReading custom repository "
                                    >
                                        < style={{ opacity: '0.5' }} size={18} />
                                    </EmailShareButton> */}
                </span>
              </div>
            </Col>
          </Row>
        </Container>
        <Container className="mt-3 px-0">
          <Row>
            <Col lg={6} className="px-1 mb-2">
              <div className="vehicleDetailsImg">
                {imagesArr.length > 0 ? (
                  <img
                    src={`${imagesArr[0].fileNameImage}`}
                  />
                ) : (
                  <img src={"assets/images/no-image.avif"} />
                )}
              </div>
            </Col>
            <Col lg={6} className="text-right px-1 mb-4">
              <div className="collapsImg">
                <div className="nft_pic nft_multi">
                  <a className="">
                    {imagesArr.length > 1 ? (
                      <img
                        src={`${imagesArr[1].fileNameImage}`}
                      />
                    ) : (
                      <img src={"assets/images/no-image.avif"} />
                    )}
                  </a>
                  <a className="">
                    {imagesArr.length > 2 ? (
                      <img
                        src={`${imagesArr[2].fileNameImage}`}
                      />
                    ) : (
                      <img src={"assets/images/no-image.avif"} />
                    )}
                  </a>
                  <a className="">
                    {imagesArr.length > 3 ? (
                      <img
                        src={`${imagesArr[3].fileNameImage}`}
                      />
                    ) : (
                      <img src={"assets/images/no-image.avif"} />
                    )}
                  </a>
                  <a className="">
                    {imagesArr.length > 4 ? (
                      <img
                        src={`${imagesArr[4].fileNameImage}`}
                      />
                    ) : (
                      <img src={"assets/images/no-image.avif"} />
                    )}
                    {imagesArr.length > 1 ? (
                      <Button
                        variant="default"
                        className="viewmore position-absolute rounded-2 btn-sm h-auto text-white border"
                        onClick={handleOpenview}
                      >
                        View More
                      </Button>
                    ) : (
                      ""
                    )}
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <div className=" mb-4">
          <Container>
            <Row>
              <Col lg={8}>
                <div className="amenities_list mb-5">
                  <Row>
                    <Col lg={4} md={4} xs={6}>
                      <div className="text-center border-end">
                        {/* <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                          <path d="M16.0499 24.3399C16.0491 25.0408 16.1912 25.7346 16.4677 26.3788C16.7441 27.0227 17.1488 27.6035 17.6572 28.0857C18.6615 29.0524 20.0031 29.5897 21.397 29.5835H21.3997C21.4705 29.5835 21.5502 29.5835 21.6312 29.5785C23.0275 29.5052 24.341 28.8934 25.2956 27.8717C26.2505 26.8496 26.7718 25.4972 26.7499 24.0987L26.7499 24.0987L26.7498 24.0944C26.6934 22.3694 26.0515 20.5767 25.2568 18.9887C24.4606 17.3976 23.5013 15.9931 22.7904 15.0402C22.6297 14.8239 22.4201 14.6487 22.1788 14.5288L22.0679 14.7519L22.1788 14.5288C21.9379 14.4091 21.6722 14.3479 21.4033 14.3502C21.1334 14.3493 20.8671 14.4118 20.6258 14.5327C20.3841 14.6537 20.1744 14.8299 20.0134 15.0469C19.2764 16.0311 18.2886 17.4807 17.4839 19.1159C16.6809 20.7478 16.05 22.5854 16.0499 24.3399ZM16.0499 24.3399C16.0499 24.3398 16.0499 24.3398 16.0499 24.3397L16.2999 24.34H16.0499C16.0499 24.34 16.0499 24.3399 16.0499 24.3399ZM21.12 15.8746L21.3202 16.0243C21.3297 16.0116 21.3421 16.0013 21.3563 15.9942C21.3706 15.9871 21.3863 15.9834 21.4022 15.9835L21.4022 15.9835L21.4075 15.9835C21.4206 15.9832 21.4336 15.9862 21.4453 15.992L21.5558 15.7677L21.4453 15.992C21.4571 15.9978 21.4673 16.0063 21.4752 16.0168L21.4758 16.0177C22.0094 16.7302 22.8969 17.9985 23.6628 19.4767C24.4308 20.9589 25.0635 22.6273 25.1144 24.1471C25.1279 25.1171 24.7652 26.0547 24.1023 26.7632C23.4392 27.472 22.5272 27.8963 21.5579 27.947C21.0498 27.9695 20.5424 27.8889 20.0662 27.7103C19.5898 27.5316 19.1544 27.2583 18.7862 26.9069L18.7856 26.9063C18.4371 26.576 18.1596 26.178 17.9701 25.7368C17.7805 25.2956 17.6829 24.8204 17.6833 24.3402V24.34C17.6833 22.8062 18.3065 21.1035 19.0836 19.5827C19.8579 18.0674 20.7707 16.7601 21.3203 16.0242L21.12 15.8746ZM21.12 15.8746C21.1529 15.8306 21.1957 15.7949 21.2449 15.7704C21.2941 15.7459 21.3484 15.7332 21.4033 15.7335L17.4333 24.34C17.4333 21.1537 20.0116 17.3587 21.12 15.8746Z" fill="#E46422" stroke="#E46422" stroke-width="0.5" />
                          <path d="M30.4666 4.15H30.4669C31.735 4.15143 32.9508 4.65581 33.8475 5.5525C34.7441 6.44918 35.2485 7.66494 35.2499 8.93305V8.93333V32.1666V32.1669C35.249 32.9843 34.9238 33.7679 34.3459 34.3459C33.7679 34.9238 32.9843 35.249 32.1669 35.25H32.1666H10.6333H10.633C9.81565 35.249 9.03204 34.9238 8.45407 34.3459C7.8761 33.7679 7.55097 32.9843 7.54999 32.1669V32.1666L7.54999 12.1395C7.54999 12.1394 7.54999 12.1393 7.54999 12.1392V12.139H7.79999C7.79888 11.5832 7.96234 11.0396 8.26976 10.5767L30.4666 4.15ZM30.4666 4.15H15.5392M30.4666 4.15L8.44738 1.48877C8.44749 1.48888 8.4476 1.489 8.44771 1.48911L10.8837 3.92515C11.2314 3.64035 11.6684 3.48282 12.1217 3.48282C12.6388 3.48282 13.1348 3.68785 13.5009 4.05297L13.5013 4.0533L14.005 4.55745C14.4707 4.28992 14.9997 4.14879 15.5392 4.15M15.5392 4.15C15.5393 4.15 15.5394 4.15 15.5395 4.15L15.5389 4.4M15.5392 4.15H15.5389V4.4M15.5389 4.4H30.4666L13.9681 4.8743C14.4331 4.5638 14.9799 4.39869 15.5389 4.4ZM7.45306 10.1118L7.95346 10.6135L8.27032 1.66527C8.06032 1.45381 7.81044 1.28612 7.53516 1.17192C7.25988 1.05773 6.96468 0.999292 6.66666 1.00001V0.750006H6.66636H2.7C2.18283 0.750006 1.68684 0.955452 1.32114 1.32115C0.955446 1.68684 0.75 2.18283 0.75 2.7V3.83334C0.75 4.35051 0.955446 4.8465 1.32114 5.21219C1.68684 5.57789 2.18283 5.78333 2.7 5.78333L5.02292 5.78333C5.02301 5.78333 5.02311 5.78333 5.0232 5.78333C5.40791 5.78403 5.77683 5.93641 6.0499 6.20739C6.05 6.20749 6.0501 6.2076 6.05021 6.2077L7.32781 7.48481C7.20319 7.63408 7.10145 7.80149 7.02627 7.98158C6.92726 8.21874 6.87628 8.47318 6.87628 8.73018C6.87628 8.98717 6.92726 9.24161 7.02627 9.47877C7.12515 9.71566 7.26999 9.93059 7.45242 10.1112C7.45263 10.1114 7.45285 10.1116 7.45306 10.1118ZM7.20437 5.05222L7.20382 5.05168C6.62421 4.47587 5.8409 4.15187 5.0239 4.15H5.02333H2.7C2.61601 4.15 2.53547 4.11664 2.47608 4.05725C2.41669 3.99787 2.38333 3.91732 2.38333 3.83334V2.7C2.38333 2.61602 2.41669 2.53547 2.47608 2.47609C2.53547 2.4167 2.61601 2.38334 2.7 2.38334L6.66666 2.38334L6.66687 2.38334C6.78269 2.38324 6.89739 2.40606 7.00434 2.45049C7.1113 2.49493 7.20841 2.56009 7.29006 2.64223L7.29058 2.64275L9.72062 5.07279L8.47413 6.32149L7.20437 5.05222ZM8.53072 8.61031C8.54195 8.58395 8.55676 8.55934 8.57471 8.53715L8.60535 8.50645L11.8977 5.20846L11.8978 5.20839C11.9272 5.1789 11.9621 5.1555 12.0006 5.13954C12.0391 5.12357 12.0803 5.11535 12.1219 5.11535C12.1636 5.11535 12.2048 5.12357 12.2433 5.13954C12.2818 5.1555 12.3167 5.1789 12.3461 5.20839L12.7733 5.63678L9.02892 9.3812L8.59993 8.95302L8.59994 8.95301L8.59847 8.95157C8.56907 8.92271 8.54575 8.88825 8.52987 8.85022C8.514 8.8122 8.50589 8.77139 8.50604 8.73018C8.50619 8.68898 8.51458 8.64822 8.53072 8.61031ZM9.18332 12.139L9.18332 12.1382C9.18277 11.9479 9.21999 11.7593 9.29283 11.5835C9.36568 11.4076 9.47269 11.248 9.60768 11.1138L9.6082 11.1133L14.5133 6.20821L14.5137 6.20779C14.648 6.07286 14.8077 5.96588 14.9835 5.89302C15.1594 5.82017 15.348 5.78289 15.5384 5.78333H15.5389H30.4664C31.3016 5.78417 32.1024 6.11633 32.693 6.70694C33.2836 7.29754 33.6158 8.09834 33.6166 8.93358V32.1666C33.6166 32.5512 33.4638 32.92 33.1919 33.1919C32.92 33.4639 32.5512 33.6166 32.1666 33.6166H10.6333C10.2488 33.6166 9.87994 33.4639 9.60802 33.1919C9.33609 32.92 9.18332 32.5512 9.18332 32.1666L9.18332 12.139Z" fill="#E46422" stroke="#E46422" stroke-width="0.5" />
                          <path d="M30.4878 6.4165H30.4876L25.3547 6.4165L25.3545 6.4165C24.9718 6.41693 24.5977 6.53078 24.2797 6.74369C23.9617 6.95659 23.7139 7.25899 23.5677 7.61266C23.4214 7.96634 23.3833 8.35543 23.4581 8.73076C23.5329 9.10607 23.7173 9.45078 23.9879 9.72134C23.988 9.72136 23.988 9.72139 23.988 9.72141L29.6771 15.4127C29.6773 15.413 29.6775 15.4132 29.6777 15.4134C29.8551 15.5933 30.0663 15.7363 30.2992 15.8341C30.5324 15.932 30.7827 15.9827 31.0356 15.9832L31.0369 15.9832C31.2945 15.9824 31.5494 15.931 31.7872 15.8319C32.1429 15.6885 32.4473 15.4413 32.6607 15.1225C32.8741 14.8036 32.9865 14.4277 32.9833 14.044V8.9122V8.91201C32.9828 8.25032 32.7197 7.61586 32.2518 7.14797C31.7839 6.68008 31.1495 6.417 30.4878 6.4165ZM31.35 14.0447C31.3499 14.1046 31.3321 14.1631 31.2988 14.2129C31.2655 14.2626 31.2182 14.3014 31.1629 14.3243C31.1076 14.3472 31.0468 14.3533 30.988 14.3416C30.9294 14.33 30.8755 14.3014 30.8332 14.2592C30.8331 14.2591 30.833 14.2591 30.833 14.259L25.1408 8.56685C25.1408 8.5668 25.1407 8.56675 25.1407 8.5667C25.0985 8.52432 25.0698 8.47041 25.0582 8.41176C25.0465 8.35303 25.0526 8.29218 25.0755 8.23687C25.0984 8.18157 25.1372 8.13429 25.187 8.10101C25.2367 8.06775 25.2951 8.04994 25.3549 8.04984H30.4874C30.716 8.05022 30.9352 8.14123 31.0969 8.30291L31.2737 8.12614L31.0969 8.30291C31.2585 8.46457 31.3495 8.68369 31.35 8.9123C31.35 8.91239 31.35 8.91249 31.35 8.91258L31.35 14.0447Z" fill="#E46422" stroke="#E46422" stroke-width="0.5" />
                        </svg> */}
                        <img src={"assets/images/petrol.svg"} />
                        {engineArr.length > 0 ? (
                          <p className="mt-2">{engineArr[0].name}</p>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>
                    <Col lg={4} md={4} xs={6}>
                      <div className="text-center border-end">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="29"
                          height="35"
                          viewBox="0 0 29 35"
                          fill="none"
                        >
                          <path
                            d="M26.5833 27.0456H25.7358L24.972 12.7274C24.9691 10.0926 22.807 7.95758 20.1387 7.95466H19.3333V6.36356H20.9443C21.8338 6.36268 22.5545 5.65102 22.5554 4.77274V3.18192C22.5533 1.42536 21.1119 0.00203914 19.3333 0H9.66667C7.8878 0.00203914 6.44641 1.42536 6.44435 3.18192V4.77274C6.44523 5.65102 7.16592 6.36268 8.05536 6.36356H9.66667V7.95466H8.86101C6.20746 7.95204 4.04921 10.0652 4.02915 12.6855L3.26392 27.0456H2.41667C1.08237 27.0471 0.001475 28.1144 0 29.432V30.2273C0.00294999 32.8621 2.16503 34.9971 4.83333 35H24.1667C26.8347 34.9971 28.9971 32.8621 29 30.2273V29.432C28.9985 28.1144 27.9173 27.0471 26.5833 27.0456ZM8.05536 3.18192C8.05624 2.30364 8.77723 1.59169 9.66667 1.59082H19.3333C20.2228 1.59169 20.9435 2.30364 20.9443 3.18192V4.77274H8.05536V3.18192ZM11.2777 6.36356H17.722V7.95466H11.2777V6.36356ZM5.63869 12.7274C5.64076 10.9708 7.08214 9.54752 8.86101 9.54548H20.1387C20.9998 9.54898 21.8238 9.89126 22.4288 10.496C23.0339 11.101 23.3699 11.919 23.3625 12.7694L24.1236 27.0456H22.107L21.355 14.3182C21.3529 12.5617 19.9115 11.1383 18.1327 11.1363H10.867C9.10439 11.1325 7.66773 12.5314 7.64648 14.2716L6.89275 27.0456H4.8764L5.63869 12.7274ZM20.4936 27.0456H8.50612L9.25602 14.3182C9.25691 13.4399 9.9776 12.7283 10.867 12.7274H18.133C18.5675 12.7306 18.9826 12.9057 19.2858 13.2133C19.5888 13.5212 19.7543 13.9357 19.7457 14.3648L20.4936 27.0456ZM27.3887 30.2273C27.3866 31.9838 25.9452 33.4069 24.1667 33.4092H4.83333C3.05446 33.4069 1.61337 31.9838 1.61101 30.2273V29.432C1.6119 28.993 1.9721 28.6373 2.41667 28.6364H26.5833C27.0279 28.6373 27.3878 28.993 27.3887 29.432V30.2273Z"
                            fill="#E46422"
                          />
                        </svg>
                        <p className="mt-2">{vehicleDetails.seats} Seats</p>
                      </div>
                    </Col>

                    <Col lg={4} md={4} xs={6}>
                      <div className="text-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="39"
                          height="33"
                          viewBox="0 0 39 33"
                          fill="none"
                        >
                          <path
                            d="M35.7014 10.1269C35.4201 10.0198 35.1203 9.96527 34.818 9.96607H34.7863C33.1897 9.98905 31.3991 11.436 30.4594 13.6244C29.333 16.2425 29.8515 18.9211 31.6263 19.6097C31.9073 19.7168 32.2068 19.7713 32.5089 19.7705C34.1135 19.7705 35.9286 18.3152 36.8762 16.1123C37.9947 13.4942 37.4683 10.8155 35.7014 10.1269V10.1269Z"
                            stroke="#E46422"
                            stroke-width="3"
                            stroke-miterlimit="10"
                          />
                          <path
                            d="M25.4003 20.3436C23.1996 16.8102 22.2497 15.4812 19.7324 15.4812C17.2151 15.4812 16.2572 16.8186 14.0566 20.3436C12.1726 23.3585 8.36494 23.6097 7.41501 26.1704C7.2223 26.6394 7.12551 27.1402 7.13003 27.6449C7.13003 29.7276 8.77657 31.4135 10.8031 31.4135C13.3204 31.4135 16.748 29.4687 19.7403 29.4687C22.7326 29.4687 26.1444 31.4135 28.6617 31.4135C30.6882 31.4135 32.3268 29.7283 32.3268 27.6449C32.3287 27.1397 32.2292 26.6389 32.0339 26.1704C31.084 23.6005 27.2843 23.3585 25.4003 20.3436Z"
                            stroke="#E46422"
                            stroke-width="3"
                            stroke-miterlimit="10"
                          />
                          <path
                            d="M14.7056 12.1109C14.8116 12.1109 14.9174 12.1033 15.0222 12.0879C16.8596 11.8297 18.0066 9.36637 17.5902 6.58436C17.1984 3.96166 15.5534 2 13.8333 2C13.7273 1.99992 13.6214 2.0076 13.5166 2.02298C11.6793 2.28111 10.5323 4.74449 10.9486 7.5265C11.3405 10.1415 12.9854 12.1109 14.7056 12.1109Z"
                            stroke="#E46422"
                            stroke-width="3"
                            stroke-miterlimit="10"
                          />
                          <path
                            d="M28.5126 7.5265C28.929 4.74449 27.782 2.28111 25.9447 2.02298C25.8399 2.0076 25.734 1.99992 25.628 2C23.9079 2 22.2661 3.96166 21.8734 6.58436C21.4571 9.36637 22.6041 11.8297 24.4414 12.0879C24.5462 12.1033 24.6521 12.1109 24.7581 12.1109C26.4782 12.1109 28.1232 10.1415 28.5126 7.5265V7.5265Z"
                            stroke="#E46422"
                            stroke-width="3"
                            stroke-miterlimit="10"
                          />
                          <path
                            d="M7.83953 19.6097C9.61193 18.9203 10.1296 16.2394 9.00477 13.6244C8.05801 11.4214 6.24444 9.96607 4.64223 9.96607C4.34016 9.96527 4.04067 10.0199 3.75959 10.1269C1.98719 10.8163 1.46948 13.4972 2.59435 16.1123C3.54111 18.3152 5.35468 19.7705 6.95689 19.7705C7.25896 19.7713 7.55846 19.7168 7.83953 19.6097V19.6097Z"
                            stroke="#E46422"
                            stroke-width="3"
                            stroke-miterlimit="10"
                          />
                        </svg>
                        <p className="mt-2">No Pets Allowed</p>
                      </div>
                    </Col>
                  </Row>
                </div>


                <Col lg={12} className="mb-5">
                  <div>
                    <h5 className="mb-3">
                      <b>Pickup Location</b>
                    </h5>
                    <p className="text-grey">
                     {vehicleDetails.location}
                    </p>
                  </div>
                </Col>
                <Col lg={12} className="mb-5">
                  <div>
                    <h5 className="mb-3">
                      <b>Vehicle Description</b>
                    </h5>
                    <p className="text-grey">
                      <div dangerouslySetInnerHTML={createMarkup()} />
                    </p>
                  </div>
                </Col>

                <Col lg={12} className="mb-5">
                  <div>
                    <h5 className="mb-3">
                      <b>Terms</b>
                    </h5>
                    <Row>
                      <Col lg={6} className="mb-2">
                        <p className="text-grey">
                          <div dangerouslySetInnerHTML={createMarkupTerms()} />
                        </p>
                      </Col>
                    </Row>
                  </div>
                </Col>

                <Col lg={12} className="mb-5">
                  <div>
                    <h5 className="mb-3">
                      <b>Offered Features</b>
                    </h5>
                    <Row>
                      {vehicleFeaturesArr.length > 0
                        ? vehicleFeaturesArr.map((data) => (
                          <Col lg={4}>
                            <div className="">
                              <p>
                                {data.name == "Pet Friendly" ? (
                                  <LuDog />
                                ) : data.name == "GPS" ? (
                                  <MdGpsFixed />
                                ) : data.name == "Power Steering" ? (
                                  <GiSteeringWheel />
                                ) : data.name == "Bluetooth" ? (
                                  <FaBluetoothB />
                                ) : data.name == "Sunroof" ? (
                                  <IoSunnyOutline />
                                ) : data.name == "Voice Control" ? (
                                  <MdOutlineKeyboardVoice />
                                ) : data.name == "Voice" ? (
                                  <MdOutlineKeyboardVoice />
                                ) : (
                                  ""
                                )}
                                &nbsp;{data.name}
                              </p>
                            </div>
                          </Col>
                        ))
                        : ""}
                    </Row>
                    {/* <Button variant="" className="border border-dark rounded-2">
                      Show All 10 Amenities
                    </Button> */}
                  </div>
                </Col>
                <Col lg={12} className="mb-5">
                  <div>
                    <h5 className="mb-3">
                      <b>Engine Types</b>
                    </h5>
                    <Row>
                      {engineArr.length > 0
                        ? engineArr.map((data) => (
                          <Col lg={4}>
                            <div className="">
                              <p>
                                {data.name == "Electric" ? (
                                  <MdElectricCar />
                                ) : data.name == "GPS" ? (
                                  <MdGpsFixed />
                                ) : data.name == "Diesel" ||
                                  data.name == "Petrol" ||
                                  data.name == "CNG" ? (
                                  <BsFillFuelPumpDieselFill />
                                ) : data.name == "Bluetooth" ? (
                                  <FaBluetoothB />
                                ) : data.name == "Sunroof" ? (
                                  <IoSunnyOutline />
                                ) : data.name == "Music" ? (
                                  <FaMusic />
                                ) : data.name == "Voice" ? (
                                  <MdOutlineKeyboardVoice />
                                ) : (
                                  ""
                                )}
                                &nbsp;{data.name}
                              </p>
                            </div>
                          </Col>
                        ))
                        : ""}
                    </Row>
                    {/* <Button variant="" className="border border-dark rounded-2">
                      Show All 10 Amenities
                    </Button> */}
                  </div>
                </Col>
                {!vehicleDetails.video ||
                          vehicleDetails.video == null ||
                          vehicleDetails.video == undefined ? (
                ""
                        ) :(
                <Col lg={12} className="mb-3">
                  <div>
                    <h5 className="mb-3">
                      <b>Video</b>
                    </h5>
                    <Row>
                      <Col lg="6">
                       
                          <>
                            <video width="300" controls>
                              <source
                                src={config.imageUrl + vehicleDetails.video}
                              />
                            </video>
                            <br />
                            <br />
                            <a
                              href={config.imageUrl + vehicleDetails.video}
                              target="_blank"
                            >
                              <Button
                                variant="primary"
                                className="rounded-2 h-auto mb-3"
                              >
                                View Video
                              </Button>
                    
                            </a>
                          </>
                     
                      </Col>
                      <Col lg="6" style={{ display: "none" }}>
                        {!vehicleDetails.document ||
                          vehicleDetails.document == null ||
                          vehicleDetails.document == undefined ? (
                          <p>No data found!!</p>
                        ) : (
                          <>
                            <iframe
                              src={config.imageUrl + vehicleDetails.document}
                              frameborder="0"
                            ></iframe>
                            <br />
                            <br />
                            <a
                              href={config.imageUrl + vehicleDetails.document}
                              target="_blank"
                            >
                              <Button
                                variant="primary"
                                className="rounded-2 h-auto mb-3"
                              >
                                View Document
                              </Button>
                              {/* <Button onClick={() => changeVehicleStatus(1)} variant="primary" className="rounded-2 h-auto mb-3">
                              View Document
                            </Button> */}
                            </a>
                          </>
                        )}
                      </Col>
                    </Row>
                  </div>
                </Col>
                   )}
              </Col>
              <Col lg={4} className="mb-4">
                <div>
                  {/* ---------- */}
                  <Card className="rounded-4">
                    <div className="d-flex justify-content-between border-bottom border-grey p-4 mb-4">
                      <div>
                        <h5 className="mb-0">
                          <b>${vehicleDetails.perHourRate}/Hour</b>
                        </h5>
                      </div>
                      <div>
                        <Button
                          variant="primary"
                          className="rounded-5"
                          onClick={handleOpenHost}
                          style={{ cursor: "pointer", marginTop: "-10px" }}
                        >
                          Contact Host
                        </Button>
                      </div>
                    </div>
                    <div className="px-4 pb-4 two_month_date">
                      <Row className="align-items-center">
                        <Col lg={12}>
                          {/* <Button variant="" className="w-100 mb-4 text-black border-dark rounded-5"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 22" fill="none">
                                                        <path d="M14.5 7.16H5.5C5.08579 7.16 4.75 7.49579 4.75 7.91C4.75 8.32421 5.08579 8.66 5.5 8.66H14.5C14.9142 8.66 15.25 8.32421 15.25 7.91C15.25 7.49579 14.9142 7.16 14.5 7.16Z" fill="black" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.89 2.57H15C17.7614 2.57 20 4.80858 20 7.57V16.57C20 19.3314 17.7614 21.57 15 21.57H5C3.67392 21.57 2.40215 21.0432 1.46447 20.1055C0.526784 19.1679 0 17.8961 0 16.57V7.57C0 4.80858 2.23858 2.57 5 2.57H5.09V0.75C5.09 0.335786 5.42579 0 5.84 0C6.25421 0 6.59 0.335786 6.59 0.75V2.57H13.39V0.75C13.39 0.335786 13.7258 0 14.14 0C14.5542 0 14.89 0.335786 14.89 0.75V2.57ZM15 20.07C16.933 20.07 18.5 18.503 18.5 16.57V7.57C18.5 5.637 16.933 4.07 15 4.07H5C3.067 4.07 1.5 5.637 1.5 7.57V16.57C1.5 18.503 3.067 20.07 5 20.07H15Z" fill="black" />
                                                    </svg>&nbsp;5 - 8 October</Button> */}

                          <Button
                            variant=""
                            className="w-100 mb-4 text-black border-dark rounded-5 position-relative h-auto py-2"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 20 22"
                              fill="none"
                            >
                              <path
                                d="M14.5 7.16H5.5C5.08579 7.16 4.75 7.49579 4.75 7.91C4.75 8.32421 5.08579 8.66 5.5 8.66H14.5C14.9142 8.66 15.25 8.32421 15.25 7.91C15.25 7.49579 14.9142 7.16 14.5 7.16Z"
                                fill="black"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M14.89 2.57H15C17.7614 2.57 20 4.80858 20 7.57V16.57C20 19.3314 17.7614 21.57 15 21.57H5C3.67392 21.57 2.40215 21.0432 1.46447 20.1055C0.526784 19.1679 0 17.8961 0 16.57V7.57C0 4.80858 2.23858 2.57 5 2.57H5.09V0.75C5.09 0.335786 5.42579 0 5.84 0C6.25421 0 6.59 0.335786 6.59 0.75V2.57H13.39V0.75C13.39 0.335786 13.7258 0 14.14 0C14.5542 0 14.89 0.335786 14.89 0.75V2.57ZM15 20.07C16.933 20.07 18.5 18.503 18.5 16.57V7.57C18.5 5.637 16.933 4.07 15 4.07H5C3.067 4.07 1.5 5.637 1.5 7.57V16.57C1.5 18.503 3.067 20.07 5 20.07H15Z"
                                fill="black"
                              />
                            </svg>
                            &nbsp;
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 22" fill="none">
                                                            <path d="M14.5 7.16H5.5C5.08579 7.16 4.75 7.49579 4.75 7.91C4.75 8.32421 5.08579 8.66 5.5 8.66H14.5C14.9142 8.66 15.25 8.32421 15.25 7.91C15.25 7.49579 14.9142 7.16 14.5 7.16Z" fill="black" />
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.89 2.57H15C17.7614 2.57 20 4.80858 20 7.57V16.57C20 19.3314 17.7614 21.57 15 21.57H5C3.67392 21.57 2.40215 21.0432 1.46447 20.1055C0.526784 19.1679 0 17.8961 0 16.57V7.57C0 4.80858 2.23858 2.57 5 2.57H5.09V0.75C5.09 0.335786 5.42579 0 5.84 0C6.25421 0 6.59 0.335786 6.59 0.75V2.57H13.39V0.75C13.39 0.335786 13.7258 0 14.14 0C14.5542 0 14.89 0.335786 14.89 0.75V2.57ZM15 20.07C16.933 20.07 18.5 18.503 18.5 16.57V7.57C18.5 5.637 16.933 4.07 15 4.07H5C3.067 4.07 1.5 5.637 1.5 7.57V16.57C1.5 18.503 3.067 20.07 5 20.07H15Z" fill="black" />
                                                        </svg> */}
                            {/* &nbsp; */}
                            {/* {values.slice(0, 1).map((day, index) => (
                                                            <>{day.format()[8]}{day.format()[9]}/{day.format()[6]}{day.format()[7]}</>
                                                        ))}
                                                        -
                                                          {values.slice(1, 2).map((day, index) => (
                                                            <>{day.format()[8]}{day.format()[9]}/{day.format()[6]}{day.format()[7]}</>
                                                        ))} */}
                            {values.slice(0, 1).map((day, index) => (
                              <>{day.format()}</>
                            ))}
                            -
                            {values.slice(1, 2).map((day, index) => (
                              <>{day.format()}</>
                            ))}
                            {/* 5 October - 8 October */}
                            <DatePicker
                              value={values}
                              format="MM/DD/YYYY HH:mm"
                              minDate={moment().subtract(1, "day").toDate()}
                              onChange={setValues}
                              numberOfMonths={2}
                              plugins={[
                                <TimePicker position="right" />,
                                // <DatePanel markFocused />
                              ]}
                              range
                            />
                          </Button>

                          {/* <Button variant="" className="w-100 mb-4 text-black border-dark rounded-5"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.58 16.71L19.82 17.85C20.0474 18.8356 19.8228 19.8713 19.2076 20.6742C18.5924 21.4771 17.6508 21.9633 16.64 22H7.35997C6.34915 21.9633 5.40754 21.4771 4.79232 20.6742C4.1771 19.8713 3.95254 18.8356 4.17997 17.85L4.41997 16.71C4.69601 15.1668 6.02259 14.0327 7.58997 14H16.41C17.9774 14.0327 19.3039 15.1668 19.58 16.71ZM16.64 20.49C17.1478 20.4841 17.6256 20.2489 17.94 19.85V19.86C18.3257 19.3762 18.4759 18.7458 18.35 18.14L18.11 17C17.9768 16.1552 17.2646 15.5226 16.41 15.49H7.58998C6.73534 15.5226 6.02314 16.1552 5.88998 17L5.64998 18.14C5.52713 18.7426 5.67724 19.3687 6.05998 19.85C6.37431 20.2489 6.85219 20.4841 7.35998 20.49H16.64Z" fill="black" />
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 12H11.5C9.29082 12 7.49996 10.2092 7.49996 8.00001V5.36001C7.49729 4.46807 7.85043 3.61189 8.48113 2.98119C9.11184 2.35049 9.96802 1.99735 10.86 2.00001H13.14C14.0319 1.99735 14.8881 2.35049 15.5188 2.98119C16.1495 3.61189 16.5026 4.46807 16.5 5.36001V8.00001C16.5 10.2092 14.7091 12 12.5 12ZM10.86 3.50002C9.83271 3.50002 8.99996 4.33277 8.99996 5.36001V8.00001C8.99996 9.38073 10.1192 10.5 11.5 10.5H12.5C13.8807 10.5 15 9.38073 15 8.00001V5.36001C15 4.86671 14.804 4.39361 14.4552 4.0448C14.1064 3.69598 13.6333 3.50002 13.14 3.50002H10.86Z" fill="black" />
                                                    </svg>&nbsp;2 guests</Button> */}
                        </Col>
                        <Col lg={12} className="mb-3">
                          <div className="text-center mt-2 mb-4">
                            <h5></h5>
                            {/* <div className="d-flex justify-content-between align-items-center">
                              <div>
                                Select No. of Passenger
                              </div>
                              <div>
                                <div class="input-group">
                                  <span class="input-group-btn">
                                    <button
                                      name='passenger'
                                      onClick={e => setpassengerCount((old) => {
                                        return { ...old, ["passenger"]: (parseInt(passengerCount["passenger"]) - 1) < 0 ? 0 : (parseInt(passengerCount["passenger"]) - 1) }
                                      })}
                                      type="button"
                                      class="btn   btn-sm btn-number rounded-5 border border-secondary"
                                    >
                                      <span class="">
                                        <FontAwesomeIcon icon={faMinus} />
                                      </span>
                                    </button>
                                  </span>
                                  <input
                                    type="text"
                                    name="guestQuantity"
                                    class="form-control  input-number border-0"
                                    min="1"
                                    max="10"
                                    value={passengerCount["passenger"]}
                                  />
                                  <span class="input-group-btn">
                                    <button
                                      onClick={e => setpassengerCount((old) => {
                                        return { ...old, ["passenger"]: parseInt(passengerCount["passenger"]) + 1 }
                                      })}
                                      type="button"
                                      class="btn  btn-sm btn-number rounded-5 border border-secondary"
                                    >
                                      <span class="">
                                        <FontAwesomeIcon icon={faPlus} />
                                      </span>
                                    </button>
                                  </span>
                                </div>
                              </div>

                            </div> */}
                          </div>
                          <table width={`100%`} className="mb-3">
                            <tbody>
                              <tr>
                                <td>
                                  ${vehicleDetails.perHourRate} x{" "}
                                  {parseInt(totalBookingHour)} hours
                                </td>

                                <td className="text-right">
                                  $
                                  {parseInt(vehicleDetails.perHourRate) *
                                    parseInt(totalBookingHour)}
                                </td>
                              </tr>
                              <tr>
                                <td>Cleaning and service fee</td>
                                <td className="text-right">Included</td>
                              </tr>
                              <tr>
                                <td>Taxes</td>
                                <td className="text-right">Included</td>
                              </tr>
                              <tr>
                                <th>
                                  Total {parseInt(totalBookingHour)}-hour travel
                                </th>
                                <th className="text-right">
                                  $
                                  {parseInt(vehicleDetails.perHourRate) *
                                    parseInt(totalBookingHour)}
                                </th>
                              </tr>
                            </tbody>
                          </table>
                          <Button
                            variant="primary"
                            className="w-100 rounded-5"
                            onClick={(e) => bookHandler(e)}
                          >
                            Reserve Now
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={12} className="mb-5 mt-4">
                <div>
                  <h5 className="mb-3 d-flex align-items-center ">
                    <b className="me-2">Reviews</b> &nbsp;
                    <span className="d-flex align-items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M19.9471 7.18026C19.8843 6.99515 19.7686 6.8325 19.6143 6.71238C19.4601 6.59227 19.274 6.51995 19.0791 6.50435L13.3781 6.05141L10.9111 0.591133C10.8325 0.415269 10.7047 0.265898 10.5431 0.161048C10.3815 0.0561979 10.193 0.000350006 10.0004 0.000244291C9.80777 0.000138576 9.61922 0.0557796 9.45751 0.160452C9.2958 0.265125 9.16784 0.414356 9.08908 0.590134L6.62206 6.05141L0.921032 6.50435C0.729486 6.51952 0.546368 6.58955 0.393584 6.70605C0.2408 6.82256 0.12482 6.98061 0.0595198 7.16129C-0.00578041 7.34198 -0.017636 7.53765 0.0253714 7.72489C0.0683787 7.91214 0.164428 8.08303 0.302028 8.21712L4.51505 12.3236L3.02504 18.7747C2.9798 18.97 2.9943 19.1744 3.06666 19.3613C3.13903 19.5482 3.26591 19.7091 3.43085 19.823C3.59579 19.937 3.79117 19.9987 3.99163 20.0002C4.1921 20.0017 4.3884 19.943 4.55505 19.8316L10.0001 16.2021L15.4451 19.8316C15.6155 19.9447 15.8163 20.0029 16.0208 19.9984C16.2252 19.9939 16.4233 19.9269 16.5885 19.8065C16.7537 19.6861 16.8781 19.5179 16.9449 19.3247C17.0117 19.1315 17.0177 18.9225 16.9621 18.7257L15.1331 12.3266L19.6691 8.24512C19.9661 7.97715 20.0751 7.55921 19.9471 7.18026Z"
                          fill="#E46422"
                        />
                      </svg>{" "}
                      &nbsp;
                      <span className="text-primary">
                        {" "}
                        {vehicleDetails.ratingArr == null
                          ? "0"
                          : JSON.parse(vehicleDetails.ratingArr)
                            .map((items) => items.ratings)
                            .reduce((prev, next) => prev + next) /
                          JSON.parse(vehicleDetails.ratingArr).length}
                        {/* 5.0 */}
                      </span>
                    </span>
                  </h5>
                </div>
              </Col>

              <Col lg={12} className="mb-5">
                <div>
                  <Row>
                    {vehicleDetails.ratingArr == null
                      ? ""
                      : JSON.parse(vehicleDetails.ratingArr).map((items) => {
                        return (
                          <Col lg={4} className="mb-3">
                            <div className="d-flex align-items-center mb-2">
                              <img
                                // src="assets/images/testimonial/t1.svg"
                                src={
                                  items.ratingUserProfile == null ||
                                    items.ratingUserProfile == ""
                                    ? "assets/images/profile-img.png"
                                    : `${items.ratingUserProfile}`
                                }
                                className="me-3 reviewImg"
                              />
                              <div>
                                <h6 className="mb-0">
                                  <b>{items.ratingUserName}</b>
                                </h6>
                                <p>
                                  <div className="d-flex align-items-center">
                                    <div className="rating_star">
                                      <FaStar
                                        className="me-1"
                                        fill={
                                          items.ratings >= 1
                                            ? "rgb(228, 100, 34)"
                                            : "#b5b0b0"
                                        }
                                      />
                                      <FaStar
                                        className="me-1"
                                        fill={
                                          items.ratings >= 2
                                            ? "rgb(228, 100, 34)"
                                            : "#b5b0b0"
                                        }
                                      />
                                      <FaStar
                                        className="me-1"
                                        fill={
                                          items.ratings >= 3
                                            ? "rgb(228, 100, 34)"
                                            : "#b5b0b0"
                                        }
                                      />
                                      <FaStar
                                        className="me-1"
                                        fill={
                                          items.ratings >= 4
                                            ? "rgb(228, 100, 34)"
                                            : "#b5b0b0"
                                        }
                                      />{" "}
                                      <FaStar
                                        className="me-1"
                                        fill={
                                          items.ratings >= 5
                                            ? "rgb(228, 100, 34)"
                                            : "#b5b0b0"
                                        }
                                      />
                                    </div>
                                    &nbsp;<b>{items.ratings}</b>
                                  </div>
                                </p>
                                <p className="text-grey mb-0">
                                  {moment(items.createdDate).format("ll")}
                                </p>
                              </div>
                            </div>
                            <p className="text-grey">{items.review}</p>
                          </Col>
                        );
                      })}
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div style={{ width: "100%" }}>
          <iframe
            width="100%"
            height="400"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=1%20Grafton%20Street,%20Dublin,%20Ireland+(My%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
          >
            <a href="https://www.maps.ie/population/">
              Population calculator map
            </a>
          </iframe>
        </div>
        <hr className="mt-0" />
      </section>

      {/* Send Request to host  */}
      <Modal
        show={isHostRequestOpen}
        onHide={() => handleCloseHost(false)}
        dialogClassName="modal-90w modal-right"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b>Contact Host</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center">
            <div className="me-2">
              {!vehicleDetails?.profile ||
                vehicleDetails?.profile == null ||
                vehicleDetails?.profile == undefined ? (
                <img
                  src="assets/images/profile-img.png"
                  height={`62px`}
                  width={`100px`}
                  className="object-fit-contain rounded-2"
                />
              ) : (
                <img
                  src={`${config.imageUrl + vehicleDetails?.profile}`}
                  height={`62px`}
                  width={`100px`}
                  className="object-fit-contain rounded-2"
                />
              )}
            </div>
            <div>
              <p className="mb-0">{vehicleDetails?.firstName}</p>
              <span style={{ fontSize: "12px" }}>
                Typically responds within an hour
              </span>
            </div>
          </div>
          <br />
          <Formik
            initialValues={{
              title: "",
              message: "",
            }}
            validationSchema={AddTicketSchema}
            onSubmit={(values) => {
              formSubmit(values);
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              touched,
              values,
            }) => (
              <>
                <Form onSubmit={handleSubmit}>
                  <Form.Group
                    className="mb-4"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Title"
                      onChange={handleChange}
                      name="title"
                      value={values.title}
                    />
                    <span className="text-danger">
                      {errors.title && touched.title ? (
                        <div>{errors.title}</div>
                      ) : null}
                    </span>
                  </Form.Group>

                  <Form.Group
                    className="mb-4"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={6}
                      className="h-auto"
                      placeholder="Type your message here"
                      onChange={handleChange}
                      name="message"
                      value={values.message}
                    />
                    <span className="text-danger">
                      {errors.message && touched.message ? (
                        <div>{errors.message}</div>
                      ) : null}
                    </span>
                  </Form.Group>

                  <div className="text-right">
                    <Button
                      variant="primary"
                      className="h-auto rounded-1"
                      type="submit"
                    >
                      Submit
                    </Button>
                  </div>
                </Form>
              </>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

      <Modal
        show={isViewOpen}
        onHide={() => handleCloseview(false)}
        dialogClassName="modal-90w modal-right "
        aria-labelledby="example-custom-modal-styling-title"
        className="hotelImages"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <b>Vehicle Images</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <Swiper
              pagination={{
                type: "fraction",
              }}
              navigation={true}
              modules={[Pagination, Navigation]}
              className="mySwiper"
            >
              {imagesArr && imagesArr.length > 0
                ? imagesArr.map((obj) => {
                  return (
                    <SwiperSlide>
                      <img src={`${obj.fileNameImage}`} />
                    </SwiperSlide>
                  );
                })
                : ""}
            </Swiper>
          </>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};

export default VehicleDetails;
